export const AUTOMATIC_WORKED_HOURS_ADDITIONAL_TIMES = {
  firstInterval: 'Minutes auto - premier intervalle',
  lastInterval: 'Minutes auto - dernier intervalle',
  managerFirstInterval: 'Minutes auto - management premier intervalle',
  workedDay: 'Minutes auto - journée travaillée',
}

const HOUR_IN_MS = 60 * 60 * 1000
const FIVE_MINUTES_IN_HOURS = 5 / 60

export const roundWorkedHours = (hours) => Math.round(hours * 100) / 100

export const durationToHours = (durationMs) => (durationMs || 0) / HOUR_IN_MS

export const durationToRoundedHours = (durationMs) => roundWorkedHours(durationToHours(durationMs))

export const getWorkedHoursUserId = (user) => {
  const userId = user?._id || user
  return userId ? `${userId}` : ''
}

const getOrCreateUserLine = (byUser, userId) => {
  if (!byUser.has(userId)) {
    byUser.set(userId, {
      userId,
      hoursWorked: 0,
      nbIntervals: 0,
      additionalTimes: [],
      workToday: false,
    })
  }

  return byUser.get(userId)
}

const addAutomaticAdditionalTime = (line, commentary, hoursWorked, includeDetails) => {
  line.hoursWorked += hoursWorked

  if (includeDetails) {
    line.additionalTimes.push({
      commentary,
      hoursWorked,
    })
  }
}

export const buildDayWorkedHoursByUser = (
  day,
  { isReal = false, includeAdditionalTimeDetails = false, roundDurations = false } = {}
) => {
  const byUser = new Map()
  const getDurationHours = roundDurations ? durationToRoundedHours : durationToHours
  const automaticAdditionalTimeHours = roundDurations
    ? roundWorkedHours(FIVE_MINUTES_IN_HOURS)
    : FIVE_MINUTES_IN_HOURS
  const intervals = [...(day?.intervals || [])].sort(
    (a, b) => new Date(a.start) - new Date(b.start)
  )

  intervals.forEach((interval, intervalIndex) => {
    const isFirst = intervalIndex === 0
    const isLast = intervalIndex === intervals.length - 1
    const sessions = (interval.sessions || []).filter((session) => session.mg)

    sessions.forEach((session) => {
      const userId = getWorkedHoursUserId(session.mg)
      if (!userId) return

      const line = getOrCreateUserLine(byUser, userId)
      line.workToday = true

      if (isReal) {
        if (isFirst) {
          addAutomaticAdditionalTime(
            line,
            AUTOMATIC_WORKED_HOURS_ADDITIONAL_TIMES.firstInterval,
            automaticAdditionalTimeHours,
            includeAdditionalTimeDetails
          )
        }
        if (isLast) {
          addAutomaticAdditionalTime(
            line,
            AUTOMATIC_WORKED_HOURS_ADDITIONAL_TIMES.lastInterval,
            automaticAdditionalTimeHours,
            includeAdditionalTimeDetails
          )
        }
        if (session.category === 'management' && isFirst) {
          addAutomaticAdditionalTime(
            line,
            AUTOMATIC_WORKED_HOURS_ADDITIONAL_TIMES.managerFirstInterval,
            automaticAdditionalTimeHours,
            includeAdditionalTimeDetails
          )
        }
      }

      line.hoursWorked += getDurationHours(session.duration)
      line.nbIntervals += 1
    })
  })

  ;(day?.additionalTimes || []).forEach((additionalTime) => {
    const userId = getWorkedHoursUserId(additionalTime?.user)
    if (!userId) return

    const line = getOrCreateUserLine(byUser, userId)
    const additionalHours = getDurationHours(additionalTime.duration)
    line.hoursWorked += additionalHours

    if (includeAdditionalTimeDetails) {
      line.additionalTimes.push({
        commentary: additionalTime.commentary || '',
        hoursWorked: additionalHours,
      })
    }
  })

  byUser.forEach((line) => {
    if (line.workToday && isReal) {
      addAutomaticAdditionalTime(
        line,
        AUTOMATIC_WORKED_HOURS_ADDITIONAL_TIMES.workedDay,
        automaticAdditionalTimeHours,
        includeAdditionalTimeDetails
      )
    }
    delete line.workToday
  })

  return byUser
}
